import React from "react";
//#region types
import { CommentDetailsProps } from "models/propTypes/commentViewPropTypes";
import { CommonConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Linkify from "../linkify";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

const CommentDetails: React.FC<CommentDetailsProps> = (props) => {
  const { message = "", from, isOther, date, subject, footer, isPlaceholderMessage } = props;

  const fromName = `${from?.name ? from?.name : CommonConstants.Wint}:`;

  return (
    <Grid
      item
      xs="auto"
      className={clsx(cssExports.comment, isOther ? cssExports.commentReceived : cssExports.commentSent)}
    >
      <Grid item container direction="column">
        <Grid item container justifyContent="space-between" xs direction="row">
          {!UtilsHelper.isEmpty(fromName) ? <label className={cssExports.commentFrom}>{fromName}</label> : <></>}

          {date ? (
            <label className={clsx(cssExports.commentDate)}>
              {LocalizationHelperInstance.getFormattedDate(date.toString())}
            </label>
          ) : (
            <></>
          )}
        </Grid>
        <Grid>
          {subject && (
            <label className={clsx(cssExports.commentText, cssExports.commentSubject)}>
              <Linkify message={subject} />
            </label>
          )}
          <label className={clsx(cssExports.commentText, isPlaceholderMessage && cssExports.commentTextSecondary)}>
            <Linkify message={message} />
          </label>
        </Grid>
        {footer && (
          <Grid item container className={cssExports.commentFooterContainer}>
            {footer}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default CommentDetails;
